import './dashboard.scss';
import { useEffect } from 'react';
import usePermission from '../../shared/hooks/usePermission';
import NoAccess from '../noaccess/noaccess';
import Loader from "../../components/loader/Loader";
import { useNavigate } from 'react-router-dom';
import { Image } from '../../components/image/Image';
import { GridContainer, GridRow, GridColumn } from '../../components/grid/Grid';
import { Label } from '../../components/label/Label';
import { Component, Feature, PermissionType } from '../../services/generated';

function Dashboard() {
  const { isAuthorized, isLoading, hasAccess } = usePermission();
  useEffect(() => {
    isAuthorized(Feature.Framework,
      Component.Toolbar, PermissionType.View);
  }, []);

  const navigate = useNavigate();

  return (
    <GridContainer fluid className="dashboard-container page-wrapper">
      {isLoading && <Loader />}
      {!hasAccess && <NoAccess />}
      {hasAccess &&
          <GridRow className="align-items-start justify-content-center icons-row">
            <GridColumn columns={2} className="d-flex flex-column text-center">
              <a id="work-queue-dashboard" onClick={() => navigate('/workqueue')}>
                <Image src='/assets/icons/WebsiteWithCheckIcon.svg' alt='WebsiteWithCheckIcon' />
                <Label className="neu-display-5 text-bold icons-text">Work Queues</Label>
              </a>
            </GridColumn>
            <GridColumn columns={2} className="d-flex flex-column text-center">
              <a id="pre-registration-dashboard" onClick={() => navigate('/pre-registration')}>
                <Image src='/assets/icons/NewsIcon.svg' alt='WebsiteWithCheckIcon' />
                <Label className="neu-display-5 text-bold icons-text">Pre Registration</Label>
              </a>
              </GridColumn>
            <GridColumn columns={2} className="d-flex flex-column text-center">
              <a id="maintenance-dashboard" onClick={() => navigate('/maintenance')}>
                <Image src='/assets/icons/GearIcon.svg' alt='GearIcon' />
                <Label className="neu-display-5 text-bold icons-text">Maintenance</Label>
              </a>
            </GridColumn>
          </GridRow>
      }
    </GridContainer>
  );
}
export default Dashboard;
